<kendo-dialog
	title="SDS Details"
	*ngIf="dialogOpened"
	(close)="close('dialog')"
	[minWidth]="250"
	class="kpa-sds-dialog-container">
	<kpa-loader></kpa-loader>
	<kendo-tabstrip (tabSelect)="onTabChange($event)">
		<kendo-tabstrip-tab
			[title]="'Details'"
			[selected]="true">
			<ng-template kendoTabContent>
				<div class="kpa-sds-details-container">
					<div
						[ngClass]="{
							'kpa-sds-table-container-full': sdsDetails.isHMISEmpty && sdsDetails.isNFPAEmpty,
							'kpa-sds-table-container': !sdsDetails.isHMISEmpty || !sdsDetails.isNFPAEmpty,
						}">
						<table class="kpa-sds-view-table">
							<tr [ngClass]="{ disabled: !sdsDetails.productName }">
								<td><span>Product Name</span></td>
								<td>
									<span *ngIf="sdsDetails.productName">{{ sdsDetails.productName }}</span
									><span *ngIf="!sdsDetails.productName">None</span>
								</td>
							</tr>
							<tr [ngClass]="{ disabled: !sdsDetails.commonName }">
								<td><span>Common Name</span></td>
								<td>
									<span *ngIf="sdsDetails.commonName">{{ sdsDetails.commonName }}</span
									><span *ngIf="!sdsDetails.commonName">None</span>
								</td>
							</tr>
							<tr [ngClass]="{ disabled: !sdsDetails.appearance }">
								<td><span>Appearance</span></td>
								<td>
									<span *ngIf="sdsDetails.appearance">{{ sdsDetails.appearance }}</span
									><span *ngIf="!sdsDetails.appearance">None</span>
								</td>
							</tr>
							<tr [ngClass]="{ disabled: !sdsDetails.manufacturer }">
								<td><span>Manufacturer</span></td>
								<td>
									<span *ngIf="sdsDetails.manufacturer">{{ sdsDetails.manufacturer }}</span
									><span *ngIf="!sdsDetails.manufacturer">None</span>
								</td>
							</tr>
							<tr [ngClass]="{ disabled: !sdsDetails.quantity }">
								<td><span>Quantity</span></td>
								<td>
									<span *ngIf="sdsDetails.quantity">{{ sdsDetails.quantity }}</span
									><span *ngIf="!sdsDetails.quantity">None</span>
								</td>
							</tr>
							<tr [ngClass]="{ disabled: !sdsDetails.keywords }">
								<td><span>Keyword</span></td>
								<td>
									<span *ngIf="sdsDetails.keywords">{{ sdsDetails.keywords }}</span
									><span *ngIf="!sdsDetails.keywords">None</span>
								</td>
							</tr>
							<tr [ngClass]="{ disabled: !sdsDetails.description }">
								<td><span>Description</span></td>
								<td>
									<span *ngIf="sdsDetails.description">{{ sdsDetails.description }}</span
									><span *ngIf="!sdsDetails.description">None</span>
								</td>
							</tr>
							<tr [ngClass]="{ disabled: !sdsDetails.category }">
								<td><span>Category</span></td>
								<td>
									<span *ngIf="sdsDetails.category">{{ sdsDetails.category }}</span
									><span *ngIf="!sdsDetails.category">None</span>
								</td>
							</tr>
							<tr [ngClass]="{ disabled: !sdsDetails.locations.length }">
								<td>
									<span>Location{{ sdsDetails.locations.length > 1 ? 's' : '' }}</span>
								</td>
								<td>
									<div *ngFor="let location of sdsDetails.locations">{{ location.name }}</div>
									<div *ngIf="!sdsDetails.locations.length">Not Set</div>
								</td>
							</tr>
							<tr>
								<td></td>
								<td>
									<button
										class="kpa-view-sds-btn"
										kendoButton
										[svgIcon]="downloadIcon"
										(click)="downloadSDS(sdsDetails.fileId)">
										SDS File
									</button>
								</td>
							</tr>
						</table>
					</div>
					<div
						class="kpa-sds-hmis-nfpa"
						*ngIf="!sdsDetails.isHMISEmpty || !sdsDetails.isNFPAEmpty">
						<h4
							*ngIf="!sdsDetails.isHMISEmpty"
							style="text-align: center">
							HMIS
						</h4>
						<div
							class="hmis-container"
							*ngIf="!sdsDetails.isHMISEmpty">
							<div class="hmis-health">
								<span>HEALTH</span
								><span class="first">{{ sdsDetails.hmis[4] | replaceUnderscores }}<span *ngIf="!sdsDetails.hmis[4]">None</span></span
								><span class="second">{{ sdsDetails.hmis[1] | replaceUnderscores }}</span>
							</div>
							<div class="hmis-flammability">
								<span>FLAMMABILITY</span><span class="third">{{ sdsDetails.hmis[0] | replaceUnderscores }}</span>
							</div>
							<div class="hmis-hazard">
								<span>PHYSICAL HAZARD</span><span class="fourth">{{ sdsDetails.hmis[3] | replaceUnderscores }}</span>
							</div>
							<div class="hmis-ppe">
								<span>PERSONAL<br />PROTECTION</span><span class="fifth">{{ sdsDetails.hmis[2] | replaceUnderscores }}</span>
							</div>
						</div>
						<h4
							*ngIf="!sdsDetails.isNFPAEmpty"
							style="text-align: center">
							NFPA
						</h4>
						<div
							class="nfpa-container"
							*ngIf="!sdsDetails.isNFPAEmpty">
							<div class="nfpa-fire">
								<span class="first">{{ sdsDetails.nfpa[0] | replaceUnderscores }}</span>
							</div>
							<div class="nfpa-health">
								<span class="second">{{ sdsDetails.nfpa[1] | replaceUnderscores }}</span>
							</div>
							<div
								class="nfpa-special"
								[ngClass]="{ 'three-letters': sdsDetails.nfpa[2] >= 3, 'one-letter': sdsDetails.nfpa[2] < 3 }">
								<span
									class="third"
									[innerHTML]="sdsDetails.nfpa[2] | changeToCode | replaceUnderscores"></span>
							</div>
							<div class="nfpa-instability">
								<span class="fourth">{{ sdsDetails.nfpa[3] | replaceUnderscores }}</span>
							</div>
						</div>
					</div>
				</div>
			</ng-template>
		</kendo-tabstrip-tab>
		<kendo-tabstrip-tab [title]="'Create Labels'">
			<ng-template kendoTabContent>
				<div class="kpa-form-wrap">
					<form
						class="k-form k-form-md"
						[formGroup]="labelForm">
						<fieldset class="k-form-fieldset">
							<kendo-formfield>
								<kendo-label
									labelCssClass="k-form-label"
									[for]="rbHMIS"
									text="Format"></kendo-label>
								<kendo-dropdownlist
									#rbHMIS
									formControlName="formatType"
									[defaultItem]="defaultItem"
									[data]="formatTypes"
									textField="text"
									valueField="value"
									(valueChange)="valueChange($event)"
									[valuePrimitive]="true"
									required></kendo-dropdownlist>
								<validation-errors
									id="drpdwn_formatType_ValidationErrors"
									[control]="labelForm.get('formatType')">
								</validation-errors>
							</kendo-formfield>
							<div
								*ngIf="isGHS"
								style="text-align: left">
								<label class="control-label">Select the label elements to include:</label>
								<br />
								<a
									target="_blank"
									href="https://www.osha.gov/laws-regs/regulations/standardnumber/1910/1910.1200#1910.1200(f)">
									(OSHA GHS labeling requirements)
								</a>
								<ul
									#cblGhsOptions
									style="list-style-type: none">
									<li *ngFor="let option of ghsOptions; let i = index">
										<kendo-checkbox
											#cblGhsOptions_{{i}}
											formControlName="cblGhsOptions_{{ i }}"
											[value]="option.value"
											[valuePrimitive]="true">
										</kendo-checkbox>
										<label for="cblGhsOptions_{{ i }}">
											{{ option.label }}
										</label>
									</li>
								</ul>
							</div>
							<kendo-formfield *ngIf="isGHS">
								<kendo-label
									labelCssClass="k-form-label"
									[for]="ghsaveryType"
									text="Avery Label Type for GHS:"></kendo-label>
								<kendo-dropdownlist
									#ghsaveryType
									formControlName="ghsAveryType"
									[defaultItem]="defaultItem"
									[data]="ghsAveryTypes"
									(valueChange)="ghsAveryTypeChange($event)"
									textField="text"
									valueField="value"
									[valuePrimitive]="true"></kendo-dropdownlist>
								<validation-errors
									id="drpdwn_ghsAveryType_ValidationErrors"
									[control]="labelForm.get('ghsAveryType')">
								</validation-errors>
							</kendo-formfield>

							<kendo-formfield *ngIf="isNonGHS">
								<kendo-label
									labelCssClass="k-form-label"
									[for]="averyType"
									text="Avery Label Type:"></kendo-label>
								<kendo-dropdownlist
									#averyType
									formControlName="averyType"
									[defaultItem]="defaultItem"
									[data]="averyTypes"
									(valueChange)="averyTypeChange($event)"
									textField="text"
									valueField="value"
									[valuePrimitive]="true"></kendo-dropdownlist>
								<validation-errors
									id="drpdwn_averyType_ValidationErrors"
									[control]="labelForm.get('averyType')">
								</validation-errors>
							</kendo-formfield>
							<kendo-formfield
								*ngIf="isNonGHS"
								class="avery-label-msg">
								<p>
									<kendo-checkbox
										#averyTypePromt
										formControlName="averyTypePromt"></kendo-checkbox>
									<kendo-label
										class="k-checkbox-label"
										[for]="averyTypePromt"
										text="Include the product name, common name and manufacturer"></kendo-label>
								</p>
							</kendo-formfield>

							<div
								*ngIf="showLabelLayout"
								class="content">
								<p>Please indicate the locations of each label by clicking in the box below:</p>
								<kendo-gridlayout
									[rows]="rows"
									[cols]="cols"
									[gap]="0">
									<kendo-gridlayout-item
										*ngFor="let item of items; let i = index"
										class="box box-{{ i }}"
										(click)="onCellClick(i)"
										[ngClass]="{ selected: selectedCellIndices.includes(i) }">
									</kendo-gridlayout-item>
								</kendo-gridlayout>
								<validation-errors
									id="grid_boxSelection_ValidationErrors"
									[control]="labelForm.get('gridSelection')">
								</validation-errors>
							</div>

							<div class="k-form-buttons">
								<button
									class="kpa-view-sds-labels-btn"
									kendoButton
									[svgIcon]="downloadIcon"
									(click)="downloadLabel()">
									Download
								</button>
							</div>
						</fieldset>
					</form>
				</div>
			</ng-template>
		</kendo-tabstrip-tab>
	</kendo-tabstrip>

	<kendo-dialog-actions [layout]="'start'">
		<button
			kendoButton
			kpaKendoButton="secondary"
			(click)="close('dialog')">
			Done</button
		>&nbsp;
	</kendo-dialog-actions>
</kendo-dialog>
